import { render, staticRenderFns } from "./painel.vue?vue&type=template&id=08fb2d5e&scoped=true"
import script from "./painel.vue?vue&type=script&lang=js"
export * from "./painel.vue?vue&type=script&lang=js"
import style0 from "./painel.vue?vue&type=style&index=0&id=08fb2d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fb2d5e",
  null
  
)

export default component.exports